import apiClient from '../client';

export interface ShippingMethod {
  Id: number;
  Name: string;
}

export interface ShippingMethodInput {
  Name: string;
}

export const shippingMethodService = {
  /**
   * Get all shipping methods
   */
  getAllShippingMethods: async (): Promise<ShippingMethod[]> => {
    const response: any = await apiClient.get('/shipping-methods');
    return response.data;
  },

  /**
   * Get shipping method by ID
   */
  getShippingMethodById: async (id: number): Promise<ShippingMethod> => {
    const response: any = await apiClient.get(`/shipping-methods/${id}`);
    return response.data;
  },

  /**
   * Create a new shipping method
   */
  createShippingMethod: async (shippingMethod: ShippingMethodInput): Promise<{ id: number }> => {
    const response: any = await apiClient.post('/shipping-methods', shippingMethod);
    return response.data;
  },

  /**
   * Update a shipping method
   */
  updateShippingMethod: async (id: number, shippingMethod: ShippingMethodInput): Promise<void> => {
    await apiClient.put(`/shipping-methods/${id}`, shippingMethod);
  },

  /**
   * Delete a shipping method
   */
  deleteShippingMethod: async (id: number): Promise<void> => {
    await apiClient.delete(`/shipping-methods/${id}`);
  },
};
